import { ShipmentResponse } from '@/api/data-contracts';

export type ShipmentStatusValue = ShipmentResponse['status'];

export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatusValue, string> = {
  PENDING: 'shipment_status.pending',
  REJECTED: 'shipment_status.rejected',
  FAILED_NO_AWB: 'shipment_status.failed_no_awb',
  REGISTERED: 'shipment_status.registered',
  PICKED_UP: 'shipment_status.picked_up',
  IN_TRANSIT: 'shipment_status.in_transit',
  OUT_FOR_DELIVERY: 'shipment_status.out_for_delivery',
  PROBLEM: 'shipment_status.problem',
  UNKNOWN: 'shipment_status.unknown',
  DELIVERED: 'shipment_status.delivered',
  RETURNED: 'shipment_status.returned',
  COMPENSATED: 'shipment_status.compensated',
  CANCELLED: 'shipment_status.cancelled',
};

export type ShipmentStatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'muted';

export const SHIPMENT_STATUS_TONE_COLORS: Record<ShipmentStatusTone, string> = {
  neutral: '#615e6f',
  info: '#4592fa',
  success: '#2e9e5b',
  warning: '#d9822b',
  muted: '#a4a4b6',
};

export const getShipmentStatusTone = (status: ShipmentStatusValue): ShipmentStatusTone => {
  switch (status) {
    case 'DELIVERED':
      return 'success';
    case 'PROBLEM':
    case 'RETURNED':
    case 'REJECTED':
    case 'FAILED_NO_AWB':
      return 'warning';
    case 'PICKED_UP':
    case 'IN_TRANSIT':
    case 'OUT_FOR_DELIVERY':
      return 'info';
    case 'CANCELLED':
    case 'UNKNOWN':
      return 'muted';
    default:
      return 'neutral';
  }
};
